module.exports = __webpack_public_path__ + "img/instagram.f7921b07.svg";